export type Operands = string[] | string | Filter;
export type PredicateName = string;
export interface Filter {
  predicate: PredicateName;
  operands: Operands;
}

export interface SearchFilter {
  property: string;
  filter: Filter;
  not?: boolean;
}
type Predicate = (value: string, operands: Operands) => boolean;

export function applyFilter(
  value: string,
  filter: Filter,
  not: boolean = false
) {
  const predicateDescriptor = predicateMap[filter.predicate];
  const predicate = predicateDescriptor.predicate;
  const returnValue = predicate(value, filter.operands);
  return not ? !returnValue : returnValue;
}
const notFilter: Predicate = (value: string, operands: Operands) => {
  const filter = operands as Filter;
  return !applyFilter(value, filter);
};
const equalsFilter: Predicate = (value: string, operands: Operands) => {
  const target = operands as string;
  return value === target;
};
const containsFilter: Predicate = (value: string, operands: Operands) => {
  const target = operands as string;
  return value.includes(target);
};

export enum Predicates {
  NOT = "not",
  EQUALS = "equals",
  CONTAINS = "contains",
}
enum OperandType {
  STRING,
  FILTER,
}
interface PredicateDescriptor {
  predicate: Predicate;
  types: OperandType[];
}

export const predicateMap: { [p: PredicateName]: PredicateDescriptor } = {
  [Predicates.EQUALS]: { predicate: equalsFilter, types: [OperandType.STRING] },
  [Predicates.CONTAINS]: {
    predicate: containsFilter,
    types: [OperandType.STRING],
  },
};
